import { useLocation } from "react-router-dom";
import styles from "./termsconditions.module.css";

import { BreadCrumb, Banner } from "../../components/shared/index";

function Privacypolicy() {
  const { pathname } = useLocation();
  const parts = pathname.split("/");
  const newPath = parts[parts.length - 2];

  return (
    <section className={styles.terms__wrapper}>
      <BreadcrumbBanner
        newPath={newPath}
        heading="Privacy Policy -VITAURA"
        imageUrl="https://t4.ftcdn.net/jpg/00/54/28/13/240_F_54281395_N3triftG95Jife551rlnzHj6InhpEk9S.jpg"
      />

      <div className={styles.content}>
        <div>
          <h2>Privacy Policy – VITAURA</h2>
          <p>
            At VITAURA , we value your privacy and are committed to protecting
            your personal information. This Privacy Policy explains how we
            collect, use, store, and safeguard your data when you visit or
            purchase from our website.
          </p>
        </div>

        <div>
          <h3>1. Information We Collect</h3>
          <p>We may collect the following information:</p>
          <ul>
            <li>
              <b>Personal details:</b> Name, address, phone number, email ID
            </li>
            <li>
              <b>Payment information:</b> UPI, bank details, card details
              (securely processed through payment gateways)
            </li>
            <li>
              <b>Order information:</b> Product preference, purchase history
            </li>
            <li>
              <b>Technical data:</b> IP address, browser type, device info,
              cookies, browsing behaviour
            </li>
          </ul>
          <p>
            We do not store your complete payment information or card details.
          </p>
        </div>

        <div>
          <h3>2. How We Use Your Information</h3>
          <ul>
            <li>Process and deliver orders</li>
            <li>Provide customer support</li>
            <li>Improve website performance and shopping experience</li>
            <li>
              Send updates, offers, or promotional messages (with consent)
            </li>
          </ul>
        </div>

        <div>
          <h3>3. Data Protection & Security</h3>
          <ul>
            <li>Industry-standard security practices safeguard your data.</li>
            <li>Payment transactions are encrypted.</li>
            <li>Only authorized staff can access personal data.</li>
          </ul>
        </div>

        <div>
          <h3>4. Sharing of Information</h3>
          <ul>
            <li>
              <b>We do not sell or trade</b> your personal information.
            </li>
            <li>We only share limited information with:</li>
            <li>Trusted courier partners</li>
            <li>Secure payment gateway providers</li>
          </ul>
        </div>

        <div>
          <h3>5. Your Rights</h3>
          <ul>
            <li>Update or correct personal details anytime.</li>
            <li>Unsubscribe from marketing communications.</li>
            <li>Request deletion of your data (subject to legal needs).</li>
          </ul>
        </div>

        <div>
          <h3>6. Policy Updates</h3>
          <p>
            We may update this Privacy Policy occasionally. We recommend
            checking this page periodically to stay informed.
          </p>
        </div>

        <div>
          <h3>7. Contact Us</h3>
          <p>For any concerns regarding this policy:</p>
          <p>
            <b>Email:</b> info@vitaura.co.in
          </p>
          <p>
            <b>Phone:</b> +91 8019070584
          </p>
        </div>
      </div>
    </section>
  );
}

const BreadcrumbBanner = ({ newPath, heading, imageUrl }) => (
  <>
    <BreadCrumb customPaths={[{ label: "Privacy Policy", path: newPath }]} />
    <Banner heading={heading} imageUrl={imageUrl} />
  </>
);

export default Privacypolicy;
